<template>
    <ValidationProvider :name="name" :rules="field._validation" v-slot="validator">
        <b-field>
            <EvoLabel slot="label" :name="name" :field="field" :validator="validator"></EvoLabel>

            <!--KEYBOARD-->
            <KeyboardComponent :field="field" :step="step" :name="name" :validator="validator" v-model="value" @nextStep="nextStep()"></KeyboardComponent>
        </b-field>
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";
import KeyboardComponent from "./components/keyboard/KeyboardComponent";
import {call} from "vuex-pathify";

export default {
    components: {KeyboardComponent },
    mixins: [mixin],
    methods: {
        nextStep: call('form/goToNextStep'),
    },
}
</script>

<style lang="scss">

</style>
